/* =================================================================
   Arcturus — x-custom.js  (T-003+)
   Vanilla JS only. All deferred. No jQuery. No external libraries.
   Progressive enhancement — page must be fully usable without this.
   ================================================================= */

/* ── Cart drawer (T-006) ─────────────────────────────────────────── */
(function () {
  'use strict';

  var drawerEl, backdropEl, panelEl, itemsEl, subtotalEl;
  var shippingBar, shippingFill, shippingMsg, shippingThreshold;
  var isOpen = false;
  var i18n = {};

  function loadI18n() {
    var el = document.querySelector('[id^="x-cart-drawer-i18n-"]');
    if (!el) return;
    try { i18n = JSON.parse(el.textContent); } catch (e) {}
  }

  function t(key) { return i18n[key] || key; }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  function openDrawer() {
    if (isOpen) return;
    isOpen = true;
    drawerEl.hidden = false;
    drawerEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('x-cart-drawer--open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawerEl.classList.add('x-cart-drawer--visible');
        if (panelEl) panelEl.focus();
      });
    });
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    drawerEl.classList.remove('x-cart-drawer--visible');
    drawerEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('x-cart-drawer--open');
    setTimeout(function () { drawerEl.hidden = true; }, 260);
  }

  function trapFocus(e) {
    if (!isOpen || !panelEl) return;
    var focusables = Array.from(
      panelEl.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return !el.closest('[hidden]'); });
    if (!focusables.length) return;
    var first = focusables[0];
    var last  = focusables[focusables.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
    }
  }

  function updateShippingBar(totalPrice) {
    if (!shippingBar || !shippingThreshold) return;
    var pct = Math.min(100, Math.round((totalPrice / shippingThreshold) * 100));
    var track = shippingBar.querySelector('[role="progressbar"]');
    if (track) track.setAttribute('aria-valuenow', String(pct));
    if (shippingFill) shippingFill.style.width = pct + '%';
    if (shippingMsg) {
      if (totalPrice >= shippingThreshold) {
        shippingMsg.textContent = t('shipping_qualified');
      } else {
        var remaining = formatMoney(shippingThreshold - totalPrice);
        shippingMsg.textContent = t('shipping_remaining').replace('{{amount}}', remaining);
      }
    }
  }

  function renderCart(cart) {
    if (!itemsEl) return;
    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '<p class="x-cart-drawer__empty">' + escapeHtml(t('empty')) + '</p>';
      if (subtotalEl) subtotalEl.textContent = '';
      updateShippingBar(0);
      return;
    }
    itemsEl.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? item.image.split('?')[0] + '?width=160' : '';
      var variantLabel = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="x-cart-item__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
      return '<div class="x-cart-item" data-line-index="' + (i + 1) + '">' +
        (img ? '<img src="' + img + '" alt="' + escapeHtml(item.title) + '" width="80" height="80" loading="lazy" decoding="async" class="x-cart-item__img">' : '') +
        '<div class="x-cart-item__info">' +
          '<p class="x-cart-item__title">' + escapeHtml(item.product_title) + '</p>' +
          variantLabel +
          '<div class="x-cart-item__qty">' +
            '<button type="button" class="x-cart-item__qty-btn" data-delta="-1" aria-label="' + escapeHtml(t('decrease')) + '">−</button>' +
            '<span class="x-cart-item__qty-num">' + item.quantity + '</span>' +
            '<button type="button" class="x-cart-item__qty-btn" data-delta="1" aria-label="' + escapeHtml(t('increase')) + '">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="x-cart-item__right">' +
          '<p class="x-cart-item__price">' + formatMoney(item.final_line_price) + '</p>' +
          '<button type="button" class="x-cart-item__remove" aria-label="' + escapeHtml(t('remove')) + '">' +
            '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 4h10m-8 0v7h6V4M5 4V2.5h4V4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>';
    }).join('');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    updateShippingBar(cart.total_price);
  }

  function fetchCart(callback) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(callback)
      .catch(function (e) { console.error('[x-cart] fetch error:', e); });
  }

  function doAdd(formData, keepOpen) {
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { console.error('[x-cart] add error:', data.description); return; }
        fetchCart(function (cart) {
          renderCart(cart);
          if (!keepOpen) openDrawer();
        });
      })
      .catch(function (e) { console.error('[x-cart] add failed:', e); });
  }

  function doChange(lineIndex, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(renderCart)
    .catch(function (e) { console.error('[x-cart] change failed:', e); });
  }

  function initCartDrawer() {
    drawerEl = document.querySelector('.x-cart-drawer');
    if (!drawerEl) return;

    loadI18n();
    backdropEl   = drawerEl.querySelector('.x-cart-drawer__backdrop');
    panelEl      = drawerEl.querySelector('.x-cart-drawer__panel');
    itemsEl      = drawerEl.querySelector('[data-cart-items]');
    subtotalEl   = drawerEl.querySelector('[data-cart-subtotal]');
    shippingBar  = drawerEl.querySelector('.x-cart-drawer__shipping-bar');
    shippingFill = drawerEl.querySelector('.x-cart-drawer__shipping-fill');
    shippingMsg  = drawerEl.querySelector('[data-shipping-msg]');
    shippingThreshold = shippingBar ? parseInt(shippingBar.dataset.threshold, 10) : 0;

    /* Close actions */
    drawerEl.querySelector('.x-cart-drawer__close').addEventListener('click', closeDrawer);
    if (backdropEl) backdropEl.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) { closeDrawer(); }
      if (e.key === 'Tab' && isOpen)    { trapFocus(e); }
    });

    /* Intercept product form submissions (x-hero__form + any x-atc-form) */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList.contains('x-hero__form') && !form.classList.contains('x-atc-form')) return;
      e.preventDefault();
      doAdd(new FormData(form));
    });

    /* Drawer delegation: qty, remove, cross-sell add */
    drawerEl.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.x-cart-item__qty-btn');
      if (qtyBtn) {
        var item = qtyBtn.closest('.x-cart-item');
        var line = parseInt(item.dataset.lineIndex, 10);
        var cur  = parseInt(item.querySelector('.x-cart-item__qty-num').textContent, 10);
        var next = Math.max(0, cur + parseInt(qtyBtn.dataset.delta, 10));
        doChange(line, next);
        return;
      }
      var removeBtn = e.target.closest('.x-cart-item__remove');
      if (removeBtn) {
        var item2 = removeBtn.closest('.x-cart-item');
        doChange(parseInt(item2.dataset.lineIndex, 10), 0);
        return;
      }
      var crossBtn = e.target.closest('.x-cart-drawer__cross-sell-btn');
      if (crossBtn) {
        var fd = new FormData();
        fd.append('id', crossBtn.dataset.variantId);
        fd.append('quantity', '1');
        doAdd(fd, true);
        return;
      }
    });

    /* Discount code toggle */
    var discountToggle = drawerEl.querySelector('.x-cart-drawer__discount-toggle');
    var discountBody   = drawerEl.querySelector('.x-cart-drawer__discount-body');
    if (discountToggle && discountBody) {
      discountToggle.addEventListener('click', function () {
        var expanded = discountToggle.getAttribute('aria-expanded') === 'true';
        discountToggle.setAttribute('aria-expanded', String(!expanded));
        discountBody.hidden = expanded;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer);
  } else {
    initCartDrawer();
  }
})();

/* ── Bundle tier price updater (T-003) ───────────────────────────── */
(function () {
  'use strict';

  function initBundleTiers() {
    var fieldsets = document.querySelectorAll('.x-hero__bundle-selector');
    if (!fieldsets.length) return;

    fieldsets.forEach(function (fieldset) {
      fieldset.addEventListener('change', function (e) {
        var input = e.target;
        if (!input.classList.contains('x-hero__tier-input')) return;

        var sid = input.dataset.section;
        if (!sid) return;

        var priceEl    = document.getElementById('x-price-' + sid);
        var compareEl  = document.getElementById('x-compare-at-' + sid);
        var savingsEl  = document.getElementById('x-savings-' + sid);
        var variantEl  = document.getElementById('x-variant-id-' + sid);
        var quantityEl = document.getElementById('x-quantity-' + sid);

        var price    = input.dataset.price;
        var compare  = input.dataset.compareAt;
        var savings  = input.dataset.savings;
        var perNight = input.dataset.perNight;
        var variant  = input.dataset.variant;
        var quantity = input.dataset.quantity;

        if (priceEl && price)     { priceEl.textContent = price; }
        if (variantEl && variant)  { variantEl.value = variant; }
        if (quantityEl && quantity){ quantityEl.value = quantity; }

        if (compareEl) {
          if (compare) {
            compareEl.textContent = compare;
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        if (savingsEl) {
          if (savings) {
            savingsEl.textContent = savings;
            savingsEl.hidden = false;
          } else {
            savingsEl.hidden = true;
          }
        }

        /* T-031: update per-night display below price row */
        var perNightEl = document.getElementById('x-per-night-' + sid);
        if (perNightEl) {
          if (perNight) {
            perNightEl.textContent = perNight;
            perNightEl.hidden = false;
          } else {
            perNightEl.hidden = true;
          }
        }

        /* Update selected visual state */
        fieldset.querySelectorAll('.x-hero__tier-label').forEach(function (label) {
          label.classList.remove('x-hero__tier-label--selected');
        });
        var activeLabel = input.closest('.x-hero__tier-label');
        if (activeLabel) {
          activeLabel.classList.add('x-hero__tier-label--selected');
        }

        /* Sync gallery to variant's featured image */
        if (variant && window.galleryGoToVariant) { window.galleryGoToVariant(sid, variant); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleTiers);
  } else {
    initBundleTiers();
  }
})();

/* ── Sticky ATC bar (T-005) ─────────────────────────────────────── */
(function () {
  'use strict';

  function initStickyATC() {
    var bars = document.querySelectorAll('.x-sticky-atc');
    if (!bars.length) return;

    var heroBtn = document.querySelector('.x-hero__atc-btn');

    bars.forEach(function (bar) {
      var sid        = bar.dataset.section;
      var stickyBtn  = bar.querySelector('.x-sticky-atc__btn');
      var priceEl    = bar.querySelector('.x-sticky-atc__price');

      /* Mirror current price from hero into sticky bar */
      var heroPrice = document.querySelector('.x-hero__price');
      if (heroPrice && priceEl) {
        priceEl.textContent = heroPrice.textContent;

        var priceObs = new MutationObserver(function () {
          priceEl.textContent = heroPrice.textContent;
        });
        priceObs.observe(heroPrice, { childList: true, subtree: true, characterData: true });
      }

      /* Sticky button proxies the hero ATC submit button */
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (heroBtn && !heroBtn.disabled) {
            heroBtn.click();
          }
        });
      }

      /* Intersection Observer: show bar when hero ATC scrolls out of view */
      if (!heroBtn || !window.IntersectionObserver) return;

      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        bar.hidden = visible;
      }, { threshold: 0 });

      io.observe(heroBtn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }
})();

/* ── Product gallery — swipe + thumbnail (T-004) ────────────────── */
(function () {
  'use strict';

  /* Navigate gallery to the image associated with a variant id */
  function galleryGoToVariant(sid, variantId) {
    var mapEl     = document.getElementById('x-variant-map-' + sid);
    var galleryEl = document.getElementById('x-gallery-' + sid);
    if (!mapEl || !galleryEl || !galleryEl._goTo) return;

    var mapItem = mapEl.querySelector('[data-variant="' + variantId + '"]');
    if (!mapItem) return;

    var mediaId = mapItem.dataset.media;
    var slides  = galleryEl._slides || [];
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].dataset.mediaId === mediaId) {
        galleryEl._goTo(i);
        break;
      }
    }
  }

  /* Expose for bundle-tier handler above */
  window.galleryGoToVariant = galleryGoToVariant;

  function initGallery() {
    document.querySelectorAll('.x-gallery').forEach(function (gallery) {
      var sid    = gallery.dataset.section;
      var track  = gallery.querySelector('.x-gallery__track');
      var slides = Array.from(gallery.querySelectorAll('.x-gallery__slide'));
      var dots   = Array.from(gallery.querySelectorAll('.x-gallery__dot'));
      var thumbs = Array.from(gallery.querySelectorAll('.x-gallery__thumb'));

      if (!track || !slides.length) return;

      var current = 0;

      function goTo(index) {
        if (index < 0 || index >= slides.length) return;
        current = index;

        /* Mobile: scroll to position */
        var slideW = track.offsetWidth;
        if (slideW) {
          track.scrollTo({ left: index * slideW, behavior: 'smooth' });
        }

        /* Desktop: toggle visibility */
        slides.forEach(function (s, i) {
          var active = i === index;
          s.classList.toggle('x-gallery__slide--active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        dots.forEach(function (d, i) {
          d.classList.toggle('x-gallery__dot--active', i === index);
        });

        thumbs.forEach(function (t, i) {
          t.classList.toggle('x-gallery__thumb--active', i === index);
          t.setAttribute('aria-pressed', i === index ? 'true' : 'false');
        });
      }

      /* Mobile: sync dots/thumbs when user swipes natively */
      track.addEventListener('scroll', function () {
        var slideW = track.offsetWidth;
        if (!slideW) return;
        var index = Math.round(track.scrollLeft / slideW);
        if (index === current) return;
        current = index;
        dots.forEach(function (d, i) {
          d.classList.toggle('x-gallery__dot--active', i === index);
        });
        thumbs.forEach(function (t, i) {
          t.classList.toggle('x-gallery__thumb--active', i === index);
          t.setAttribute('aria-pressed', i === index ? 'true' : 'false');
        });
        slides.forEach(function (s, i) {
          s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
      }, { passive: true });

      /* Dot click (mobile) */
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(this.dataset.index, 10));
        });
      });

      /* Thumbnail click (desktop) */
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goTo(parseInt(this.dataset.index, 10));
        });
      });

      /* Expose goTo so bundle-tier handler can drive the gallery */
      gallery._goTo   = goTo;
      gallery._slides = slides;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }
})();

/* ── T-040: delivery date widget ────────────────────────────────── */
(function () {
  'use strict';

  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];

  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) { added++; }
    }
    return d;
  }

  function formatDate(d) {
    return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()];
  }

  function initDeliveryWidgets() {
    var widgets = document.querySelectorAll('[id^="x-delivery-widget-"]');
    if (!widgets.length) { return; }
    var today = new Date();
    widgets.forEach(function (el) {
      var days = parseInt(el.dataset.days, 10) || 4;
      var flag = el.dataset.flag || '';
      var arrival = addBusinessDays(today, days);
      var prefix = flag ? flag + ' ' : '';
      el.textContent = prefix + 'Order today, arrives ' + formatDate(arrival);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryWidgets);
  } else {
    initDeliveryWidgets();
  }
})();
